export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6294.ac67610d.jpg";